import { lazy } from 'react';

import { IRoute } from '../../types/routes';

const DashboardPage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.DashboardPage }))
);
const StudentsPage = lazy(() =>
  import('@/pages/Sales').then(module => ({ default: module.StudentsPage }))
);

export const SALES: IRoute[] = [
  {
    title: 'DASHBOARD',
    path: '/dashboard',
    icon: 'Home',
    Component: DashboardPage,
    showInMenu: true
  },
  {
    title: 'STUDENTS',
    path: '/students',
    icon: 'UserMultiple',
    Component: StudentsPage,
    showInMenu: true
  }
];
